import { Button, Divider, Space } from "antd";
import React from "react";
import { ILanguage } from "../../model/language/Language";

export interface Props {
  languages: ILanguage[];
  selectedLanguage?: ILanguage;
  onChangeLanguage: (language: ILanguage) => Promise<void>;
  showTrailingSeparator?: boolean;
}

const LanguageSelectionList = ({
  languages,
  onChangeLanguage,
  selectedLanguage,
  showTrailingSeparator = false
}: Props) => {
  return (
    <Space
      size={"small"}
      style={{ lineHeight: 1 }}
      className="language-selection"
    >
      {languages?.map((language: ILanguage, index) => {
        return (
          <span key={`language-item-${index}`}>
            <Button
              type="link"
              onClick={() => onChangeLanguage(language)}
              className={`language-menu-item ${
                selectedLanguage?.id === language.id ? "selected" : ""
              }`}
            >
              {language.name}
            </Button>
            {index !== languages?.length - 1 ? (
              <Divider
                style={{
                  backgroundColor: "white",
                  marginLeft: 8,
                  marginRight: 0
                }}
                type="vertical"
              />
            ) : showTrailingSeparator ? (
              <Divider
                style={{
                  backgroundColor: "white",
                  marginLeft: 8,
                  marginRight: 0
                }}
                type="vertical"
              />
            ) : null}
          </span>
        );
      })}
    </Space>
  );
};

export default LanguageSelectionList;
